import {
    faDoorClosed,
    faPalette,
    faGripLinesVertical,
    faUpRightAndDownLeftFromCenter,
    faDoorOpen,
    faFrame,
    fa2,
    faCamera,
    faKey,
    faShield,
    faTools,
} from "@fortawesome/pro-solid-svg-icons";

export const basePath = "/assets/doors";

export const sections = [
    {
        name: "Configuration",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faDoorOpen,
        component: "Type",
    },
    // {
    //     name: "Aperture Dimensions",
    //     visibleFor: ["trade"],
    //     view: ["external"],
    //     icon: faUpRightAndDownLeftFromCenter,
    //     component: "ApertureDimensions",
    // },
    {
        name: "Door Dimensions",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faUpRightAndDownLeftFromCenter,
        component: "DoorDimensions",
    },
    {
        name: "Door Style",
        visibleFor: ["trade", "customer"],
        view: ["external", "internal"],
        icon: faDoorClosed,
        component: "DoorStyle",
    },
    {
        name: "Opening Direction",
        subtitle: '( viewed from outside)',
        visibleFor: ["trade", "customer"],
        view: ["external", 'internal'],
        icon: faDoorOpen,
        component: "OpeningDirection",
    },
    {
        name: "Internal Frame Colour",
        visibleFor: ["trade", "customer"],
        view: ["internal", "external"],
        icon: faPalette,
        component: "InternalDoorColour",
    },
    {
        name: "Internal Panel Colour",
        visibleFor: ["trade", "customer"],
        view: ["internal", "external"],
        icon: faPalette,
        component: "InternalDoorColour",
        input_name: "internal_slab_colour",
        oxide: false
    },
    {
        name: "External Frame Colour",
        visibleFor: ["trade", "customer"],
        view: ["internal", "external"],
        icon: faPalette,
        component: "ExternalDoorColour",
        oxide:false,
    },
    {
        name: "External Panel Colour",
        visibleFor: ["trade", "customer"],
        view: ["internal", "external"],
        icon: faPalette,
        component: "ExternalDoorColour",
        oxide:true,
        input_name:'panel'
    },
    {
        name: "External Handle Style",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faGripLinesVertical,
        component: "HandleStyle",
    },
    {
        name: "Internal Handle Style",
        visibleFor: ["trade", "customer"],
        view: ["internal", 'external'],
        icon: faGripLinesVertical,
        component: "InternalHandleStyle",
    },
    {
        name: "Glass Options",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faFrame,
        component: "GlassOptions",
    },

    {
        name: "House Number",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: fa2,
        component: "HouseNumber",
    },
    {
        name: "Cill Options",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faFrame,
        component: "Cill",
    },
    {
        name: "Spy Hole",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faCamera,
        component: "SpyHole",
    },
    {
        name: "E-Key Entry",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faKey,
        component: "EKey",
    },
    {
        name: "Escutcheon",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faShield,
        component: "Escutcheon",
    },
    {
        name: "Frame Extender",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faFrame,
        component: "FrameExtender",
    },
    {
        name: "Door Hinge",
        visibleFor: ["trade", "customer"],
        view: ["external"],
        icon: faTools,
        component: "Hinge",
    },
];

// DOOR STYLE
export const handles = [
    {name: "Flat_Silver"},
    {name: "Flat_Black"},
    {name: "Curved_Black"},
    {name: "Curved_Silver"},
    {name: "Round_Black"},
    {name: "Round_Silver"},
    {name: "Square_Black"},
    {name: "Square_Silver"},
];
export const internal_handles = [
    {name: "Square_Silver"},
    {name: "Square_Black"},
    {name: "Rounded_Black"},
    {name: "Rounded_Silver"},
];

export const hinges = [
    {name: "silver", img: "hinge-silver-preview"},
    {name: "black", img: "hinge-black-preview"},
];

export const glass_options = [{name: "clear"}, {name: "satin"}];
export const escutcheon = [
    {name: "square stainless steel", img: "square-stainless-steel"},
    {name: "square black", img: "square-black"},
    {name: "round stainless steel", img: "round-stainless-steel"},
    {name: "round black", img: "round-black"},
];

export const door_types = [
    {name: "none", configuration_type: "none", configuration: "none", display: "RD1"},
    {name: "both_side", configuration_type: "sidelight", configuration: "a", display: "RD2"},
    {name: "left", configuration_type: "sidelight", configuration: "b", display: "RD3"},
    {name: "right", configuration_type: "sidelight", configuration: "c", display: "RD4"},
    // { name: "top_both", configuration_type: "toplight", configuration: "d" },
    // { name: "top_left", configuration_type: "toplight", configuration: "e" },
    // { name: "top_right", configuration_type: "toplight", configuration: "f" },
];

export const standardColors = [
    {name: "ANTHRACITE GREY", code: "ral_7016", bg: "#373f43"},
    {name: "Traffic White ", code: "ral_9910", img: "ral_9016", bg: "#f7f6f6"},
    {name: "Jet Black", code: "ral_9005", bg: "#090a0a"},
];
export const oxideColors = [
    {name: "Bruno", code: "bruno"},
    {name: "Nero", code: "nero"},
    {name: "Verderame", code: "verderame"},
];

export const nonStandardColors = [
    {name: "Pure White", code: "ral_9010", bg: "#ffffff"},
    {name: "Cream", code: "ral_9001", bg: "#f7f6e5"},
    {name: "Oyster White", code: "ral_1013", bg: "#edebc4"},
    {name: "Light Grey", code: "ral_7035", bg: "#d7d7d7"},
    {name: "Grey Aluminium", code: "ral_9007", bg: "#8e8f8f"},
    {name: "Dusty Grey", code: "ral_7037", bg: "#7d7f7d"},
    {name: "White Aluminium", code: "ral_9006", bg: "#a5a4a4"},
    {name: "Silk Grey", code: "ral_7044", bg: "#c7bd9e"},
    {name: "Pebble Grey", code: "ral_7032", bg: "#b4b084"},
    {name: "Yellow Grey", code: "ral_7034", bg: "#827649"},
    {name: "Grey Beige", code: "ral_1019", bg: "#948749"},
    {name: "Light Ivory", code: "ral_1015", bg: "#e9dd87"},
    {name: "Quartz Grey", code: "ral_7039", bg: "#6d6a61"},
    {name: "Pale Green", code: "ral_6021", bg: "#7ca15b"},
    {name: "Moss Green", code: "ral_6005", bg: "#354439"},
    {name: "Fir Green", code: "ral_6009", bg: "#31372b"},
    {name: "Olive Green", code: "ral_6003", bg: "#2f2c1e"},
    {name: "Sepia Brown", code: "ral_8014", bg: "#362c20"},
    {name: "Umbra Grey", code: "ral_7022", bg: "#322f2d"},
    {name: "Wine Red", code: "ral_3005", bg: "#4e1018"},
    {name: "Purple Red", code: "ral_3004", bg: "#6b1d21"},
    {name: "Gentian Blue", code: "ral_5010", bg: "#182a48"},
    {name: "Graphite Grey", code: "ral_7024", bg: "#484a51"},
    {name: "Black Grey", code: "ral_7021", bg: "#161517"},
];

export const doorStyles = [
    "sumatra",
    "angola",
    "bali",
    "borneo",
    "java",
    "kulon",
    "kulon-grooved",
    "malawi",
    "mowzambique",
    "nakuru",
    "savannah",
    "tanzania",
];

export const validRALRanges = [
    {min: 1000, max: 1037},
    {min: 2000, max: 3028},
    {min: 4000, max: 4010},
    {min: 5000, max: 5026},
    {min: 6000, max: 6038},
    {min: 7000, max: 7048},
    {min: 8000, max: 8029},
    {min: 9000, max: 9018},
];

// ─────────────────────────────────────────────────────────────
// Pricing constants — mirrored from PHP DoorConfigurator class.
// All amounts are in PENCE. Keep in sync with:
//   app/Services/Constants/DoorConfigurator.php
// ─────────────────────────────────────────────────────────────
export const DOOR_STYLE_PRICES_TRADE_PENCE = {
    sumatra: 205000,
    tanzania: 205000,
    angola: 215000,
    java: 215000,
    kulon: 215000,
    kulon_grooved: 223000,
    mowzambique: 235000,
    malawi: 235000,
    nakuru: 235000,
    borneo: 250000,
    bali: 252500,
    savannah: 262000,
};

export const ACCESSORIES_PRICES_TRADE_PENCE = {
    non_standard: 20000,
    dual_sided: 20000,
    electronic_lock: 40000,
    e_key_entry: 140000,
    house_number: 5000,
    frame_extender_side_35: 9500,
    frame_extender_top_35: 3000,
    spy_hole: 5000,
};

export const EXTERNAL_HANDLE_BLACK_SURCHARGE_TRADE_PENCE = 8000;
export const OXIDE_RANGE_UPGRADE_TRADE_PENCE = 360000 - (DOOR_STYLE_PRICES_TRADE_PENCE.sumatra ?? 0);
export const SIDELIGHT_TOPLIGHT_PER_AREA_TRADE_PENCE = 20000;
